import { Field } from 'react-final-form';
import theme from 'config/theme';
import { Row } from 'components/Row';
import Spacing from 'components/Spacing';
import { BodySmall } from 'components/Typography';
import Icon, { IconNames } from 'components/Icon';
import { trackEvent } from 'helpers/mixpanelEvents';
import { IssueEdit } from '../styled';
import { CloseIcon, HR, IssueTagsContainer } from './styled';

export const TagSelectField = ({ getState, allPages, userId }) => {
  const state = getState();
  const activeIssues = state.values.issues;

  const getClickHandler = (selectOrUnselect: 'select' | 'unselect', tagId) => () => {
    trackEvent('Profile Tag Selection Changed', {
      user_id: userId,
      tag_id: tagId,
      is_selected: selectOrUnselect === 'select',
    });
  };

  return (
    <>
      <IssueTagsContainer>
        {!activeIssues?.length && <span>No issues selected</span>}
        {allPages
          .filter(page => activeIssues.indexOf(page.query_str) >= 0)
          .map(page => (
            <label key={page.query_str}>
              <Field
                name="issues"
                component="input"
                type="checkbox"
                hidden
                value={page.query_str}
              />
              <IssueEdit $isSelected onClick={getClickHandler('unselect', page.id)}>
                <Row $alignItems="center">
                  <BodySmall>{page.value}</BodySmall>
                  <CloseIcon>
                    <Icon name={IconNames.XClose} size={13} color={theme.colors.shaft} />
                  </CloseIcon>
                </Row>
              </IssueEdit>
            </label>
          ))}
      </IssueTagsContainer>
      <HR />
      <span>{activeIssues.length ? 'Add more issues' : 'Add issues'}</span>
      <Spacing $size={6} />
      <IssueTagsContainer>
        {allPages
          .filter(page => activeIssues.indexOf(page.query_str) === -1)
          .map(page => (
            <label key={page.query_str}>
              <Field
                name="issues"
                component="input"
                type="checkbox"
                hidden
                value={page.query_str}
              />
              <IssueEdit $isSelected={false} onClick={getClickHandler('select', page.id)}>
                <BodySmall>
                  {page.value}
                  &nbsp;&nbsp;+
                </BodySmall>
              </IssueEdit>
            </label>
          ))}
      </IssueTagsContainer>
    </>
  );
};
